/**
 * 输入Date，输出yyyy-mm-dd日期
 * @param {*} date
 */
export function formatDateToString(date) {
  if (!date) {
    return '';
  }
  try {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const monthStr = month > 9 ? `${month}` : `0${month}`;
    const day = date.getDate();
    const dayStr = day > 9 ? `${day}` : `0${day}`;
    return `${year}-${monthStr}-${dayStr}`;
  } catch {
    return '';
  }
}
